import { toast } from "react-toastify";
import { getAll } from "./pix.service";

let CachedMethod;
let cachedMessage;
let responseFirstLenght = 0;

export let MethodToCache = ( method) => {
    CachedMethod = method;
}
export let MessageToCache = ( message) => {
    cachedMessage = message;
}

export const PullerGetAllPixKeyList = async (message, setIsWaitDBChange) => {

    const response = await getAll()

    if(responseFirstLenght === 0){
        responseFirstLenght = response.length;
    }

    if(responseFirstLenght === response.length){
        setTimeout(PullerGetAllPixKeyList, 2000);
    }else {
        toast.success(cachedMessage);
        CachedMethod(true);
        endPuller();
        return;
    }

}

function endPuller(){
    CachedMethod = undefined;
    cachedMessage = "";
    responseFirstLenght = 0;
}
